<script setup>
import {ref, onMounted} from 'vue'
import {useItemIdsStore} from '@/stores/itemIds'
import {useItemDataStore} from '@/stores/itemData'
import FormControlTypeSelect from "@/common/form-control-type/FormControlTypeSelect.vue"

const props = defineProps({
    currentData: Object,
    field: Object,
    formId: String,
})

const itemIdsStore = useItemIdsStore()
const itemDataStore = useItemDataStore()

const options = ref(null)

onMounted(async () => {
    const tableName = 'odp_event'

    const ids = await itemIdsStore.get({tableName})

    const items = await itemDataStore.preload({tableName, ids})

    options.value = items
        .filter(o => o.isArchived === 0)
        .sort((a, b) => (a.displayOrder > b.displayOrder ? 1 : -1))
        .map(o => ({
            value: o.id,
            text: o.name
        }))
})
</script>

<template>
    <FormControlTypeSelect v-if="options" :current-data="currentData" :field="field" :form-id="formId"
                           :options="options"/>
</template>